module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('gheader'), _vm._v(" "), _c('glogo'), _vm._v(" "), _c('grednav'), _vm._v(" "), _c('div', {
    staticClass: "row-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "company-info pull-left"
  }, [_c('div', {
    staticClass: "form-group basic-info"
  }, [_c('div', {
    staticClass: "basic-info-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("所在地：")]), _vm._v("\n              " + _vm._s(_vm.address) + "\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("累计询价单：")]), _vm._v("\n              " + _vm._s(_vm.infos.enquiryCount) + "\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("招投标：")]), _vm._v("\n              " + _vm._s(_vm.infos.bidCount) + "\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("招募供应商：")]), _vm._v("\n              " + _vm._s(_vm.infos.supCount) + "\n            ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-info pull-right",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "form-group shanghai",
    staticStyle: {
      "height": "520px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.companyname))])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_vm._v("电话：")]), _vm._v("\n              " + _vm._s(_vm.telephone) + "\n            ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("地址：")]), _vm._v("\n              " + _vm._s(_vm.address) + "\n            ")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.companyMaterialName))])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_vm._v("电话：")]), _vm._v("\n              " + _vm._s(_vm.MaterialTelephone) + "\n            ")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.companyByName))])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_vm._v("电话：")]), _vm._v("\n              " + _vm._s(_vm.ByTelephone) + "\n            ")])])])])])]), _vm._v(" "), _c('gfooter', {
    attrs: {
      "id": "contact-footer"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("企业实名认证")]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": "static/imgs/zizhi.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "title"
  }, [_vm._v("采购结算")]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": "static/imgs/zhifu.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-collect pull-left"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "static/imgs/guanzhu.png",
      "alt": ""
    }
  })]), _vm._v(" 收藏内容\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-purchase pull-right"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "static/imgs/dingyue.png",
      "alt": ""
    }
  })]), _vm._v(" 采购订阅\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/template-compiler?{"id":"data-v-567fbffd","hasScoped":false}!./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact/contact.vue
// module id = 295
// module chunks = 5